import {useSelector} from 'react-redux';

import {isUserLoggedIn} from 'app/reducers/commonData/selectors';

export const useUserRole = () => {
    const isCurrentUserLoggedIn = useSelector(isUserLoggedIn);
    return {isAdmin: isCurrentUserLoggedIn, isGuest: !isCurrentUserLoggedIn};
};
